

































import { Component, Vue } from "vue-property-decorator";

@Component
class ViewInviteRewardModal extends Vue {
  visible = false;

  handleToDownload() {
    this.$common.utils.helper.toFoxONEDownloadPage(this.$i18n.locale);
  }

  handleCancel() {
    this.visible = false;
  }
}
export default ViewInviteRewardModal;
